<div class="mt-16">
  <div class="flex flex-col gap-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-[24px] font-bold">Mis adhesiones enviadas</h2>
        <span class="text-[16px] text-neutral-dark">
          Solicitudes realizadas como consumidor para la adhesión a protocolos de acceso a datos de otros cedentes.
        </span>
      </div>
      <app-buttons
        [label]="'Nueva adhesión'"
        icon="pi pi-plus"
        [classes]="'bg-primary-base text-white'"
        [routerLink]="'/nueva-adhesion'" />
    </div>
    <app-tabs
      class="mt-4"
      [type]="'tabsWithURL'"
      [items]="tabsItems()" />
    <app-search-bar
      [showExternalButton]="true"
      [placeholder]="'Buscar adhesiones por identificador, nombre, procedimiento, código de organismo o protocolo.'"
      (search)="handleSearch($event)" />

    <div class="flex flex-col justify-end gap-2">
      <app-filters
        class="w-[100%]"
        [title]="'Buscar por filtros'"
        (applyFilters)="handleApplyFilters($event)"
        [filtersAdvanced]="advancedFilters"
        [containerClass]="'flex flex-row items-end gap-4 flex-wrap'" />
      <div class="flex min-w-[1200px] justify-between items-end">
        <h3 class="text-[18px] font-bold">Total de resultados: {{ totalResults() }} resultados</h3>
        <app-dropdown
          [options]="orderby.options ?? []"
          [hiddenArrow]="true"
          [label]="orderby.label ?? ''"
          [classes]="orderby.classes ?? ''"
          [icon]="orderby.icon ?? ''"
          (select)="onDropdownChange($event)" />
      </div>
    </div>
  </div>
  <div
    class="flex flex-col justify-center items-center my-4"
    *ngFor="let accession of accessions()">
    <app-accession-card
      [title]="accession.title"
      [state]="accession.state"
      [rpts]="accession.rpts"
      [detailUrl]="`/mis-adhesiones/detalles/${accession.id}`"
      [query]="'sent'"
      [validatedTime]="getValidatedTime(accession)"
      [creationDate]="getCreateDate(accession)"
      [id]="getAccessionId(accession)"
      [buttonText]="'Modificar Rpts'"
      [buttonAction]="accession.action"
      [approvedActions]="getApprovedActions(accession)"
      [service]="`${accession.serviceCode} - ${accession.service}`" />
  </div>
  <app-pagination
    [totalItems]="totalResults()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
<p-confirmdialog />
